import { render } from "./AppOtherDialog.vue?vue&type=template&id=3a0991e0&scoped=true&ts=true"
import script from "./AppOtherDialog.vue?vue&type=script&lang=ts"
export * from "./AppOtherDialog.vue?vue&type=script&lang=ts"

import "./AppOtherDialog.vue?vue&type=style&index=0&id=3a0991e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0991e0"]])

export default __exports__